import "./index.scss";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import img1 from "../../assets/img/serviceicons/img1.png";
import { Link } from "react-router-dom";
const MainServices = ({ digital, nep }) => {
  return (
    <>
      <div className="MainServicesContainer">
        <div className="wrapper">
          <div className="MainTitle">
            <div>
              <h2 className="section-label">{nep ? "सेवाहरू" : " Services"}</h2>
              <h1>
                {nep
                  ? "सर्वाङ्गीण वित्तीय सेवाहरू"
                  : "Comprehensive Financial Services"}
              </h1>
              <p>
                {nep
                  ? "अनुकूलित सेवाहरूको साथ तपाईंको वित्तीय यात्रालाई सशक्त बनाउँदै"
                  : "Empowering Your Financial Journey with Tailored Services"}
              </p>
            </div>
          </div>
          <div className="MainServicesBoxCon">
            {digital.map((digit) => {
              return (
                <div className="ServicesItems">
                  <div className="items">
                    <Link to={`services/${digit.slug}`}>
                      <img src={digit.image} alt={digit.file_alt || digit.title} />
                    </Link>
                    <h4>
                      <Link to={`services/${digit.slug}`}>{digit.title}</Link>
                    </h4>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="ViewMoreBtn">
            <Link to="/services">
              {nep ? "थप सेवाहरू" : "Explore More "}
              <ArrowRightAltIcon fontSize="small" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default MainServices;
